import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import CreateDictionarySortableItemForm from "../form/create/CreateDictionarySortableItemForm";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";

interface IComponentProps {
	/**
	 * Title for create modal
	 */
	title: string
	/**
	 * On successful created item callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Create item action
	 * @param {DictionaryItem} item
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	onCreateItem: (item: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Error handler
	 * @param err
	 * @returns {string | null}
	 */
	errorHandler?: (err: any) => string | null
}

export default class CreateDictionarySortableItemModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal autoWidth onCloseClicked={this.props.onCancel} title={`Create ${this.props.title}`}>
				<CreateDictionarySortableItemForm title={this.props.title}
												  onSuccess={this.props.onSuccess}
												  onCancel={this.props.onCancel}
												  onCreateItem={this.props.onCreateItem}
												  errorHandler={this.props.errorHandler}/>
			</Modal>
		);
	}
}
